import styled from 'styled-components'

export default styled.section`
  width: 100%;
  max-width: 800px;
  height: 186px;
  background-color: ${ ({ theme }) => theme.colors.white };
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: ease-in box-shadow 0.1s;

  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.25);
  }

  .map {
    height: 100%;
    flex-basis: 348px;
    padding: 4px;
    box-sizing: border-box;
    border-radius: 3px;
    overflow: hidden;
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 30px;
    box-sizing: border-box;
    width: 60%;

    > div {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 8px;

      .date {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 15px;
        color: ${ ({ theme }) => theme.colors.grey };
      }

      .actions-buttons {
        display: flex;
        flex-direction: row;
        gap: 8px;

        button {
          border: none;
          background: transparent;
          cursor: pointer;
        }

        img {
          width: 24px;
          height: 24px;
          z-index: 10;
        }
      }

    }
  }

  .cancelled-label {
    position: absolute;
    top: 15px;
    left: 4px;
    opacity: 0.9;
    background-color: ${ ({ theme }) => theme.colors.red };
    color: ${ ({ theme }) => theme.colors.white };
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    padding-right: 16px;
    padding-left: 12px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.iframe {
    .details {
      > div {
        flex-direction: row;
        gap: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    height: 300px;

    display: flex;
    flex-direction: column;

    .map {
      width: 100%;
      height: 200px;
    }

    .details {
      padding: 16px;
      width: 95%;
    }
  }
`
